// src/lib/modules/SpecialCollections/SpecialCollectionDetails/state/reducer.js

import {
  IS_LOADING,
  SUCCESS,
  HAS_ERROR,
  DELETE_IS_LOADING,
  DELETE_SUCCESS,
  DELETE_HAS_ERROR,
} from "./actions";

const initialState = {
  data: {},
  error: {},
  isLoading: true,
  hasError: false,
  isDeleting: false,
  deleteError: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: {},
        hasError: false,
      };
    case HAS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        hasError: true,
      };
    case DELETE_IS_LOADING:
      return {
        ...state,
        isDeleting: true,
        deleteError: {},
      };
    case DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deleteError: {},
        // Optionally clear the data since the item was deleted
        data: {},
      };
    case DELETE_HAS_ERROR:
      return {
        ...state,
        isDeleting: false,
        deleteError: action.payload,
      };
    default:
      return state;
  }
};
